import * as yup from 'yup';

export const travelMovementsExportSchema = () =>
  yup.object({
    id: yup.number(),
    code: yup.string(),
    name: yup.string(),
    exportCode1: yup.string(),
    exportCode2: yup.string(),
    isExport: yup.bool()
  });
